declare namespace $ {

	type $shm_hitalama_map_book_tools_float_quick__tool_mode_shm_hitalama_map_book_tools_float_1 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_book_tools_float['tool_mode'] >
		,
		ReturnType< $shm_hitalama_map_book_tools_float_quick['tool_mode'] >
	>
	type $shm_hitalama_map_book_tools_float_quick__draggers_suppressed_shm_hitalama_map_book_tools_float_2 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_book_tools_float['draggers_suppressed'] >
		,
		ReturnType< $shm_hitalama_map_book_tools_float_quick['draggers_suppressed'] >
	>
	type $shm_hitalama_map_book_tools_float_quick__vertical_shm_hitalama_map_book_tools_float_3 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_book_tools_float['vertical'] >
		,
		ReturnType< $shm_hitalama_map_book_tools_float_quick['vertical'] >
	>
	type $shm_hitalama_map_book_tools_float_quick__style_shm_hitalama_map_book_tools_float_4 = $mol_type_enforce<
		({ 
			'maxHeight': ReturnType< $shm_hitalama_map_book_tools_float['max_height'] >,
		})  & ReturnType< $shm_hitalama_map_book_tools_float_quick['style'] >
		,
		ReturnType< $shm_hitalama_map_book_tools_float_quick['style'] >
	>
	type $mol_button_minor__hint_shm_hitalama_map_book_tools_float_5 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['hint'] >
	>
	type $mol_button_minor__sub_shm_hitalama_map_book_tools_float_6 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_button_minor['sub'] >
	>
	type $mol_button_minor__event_shm_hitalama_map_book_tools_float_7 = $mol_type_enforce<
		({ 
			pointerdown( next?: ReturnType< $shm_hitalama_map_book_tools_float['drag_left_start'] > ): ReturnType< $shm_hitalama_map_book_tools_float['drag_left_start'] >,
		})  & ReturnType< $mol_button_minor['event'] >
		,
		ReturnType< $mol_button_minor['event'] >
	>
	type $mol_button_minor__hint_shm_hitalama_map_book_tools_float_8 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['hint'] >
	>
	type $mol_button_minor__sub_shm_hitalama_map_book_tools_float_9 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_button_minor['sub'] >
	>
	type $mol_button_minor__event_shm_hitalama_map_book_tools_float_10 = $mol_type_enforce<
		({ 
			pointerdown( next?: ReturnType< $shm_hitalama_map_book_tools_float['drag_right_start'] > ): ReturnType< $shm_hitalama_map_book_tools_float['drag_right_start'] >,
		})  & ReturnType< $mol_button_minor['event'] >
		,
		ReturnType< $mol_button_minor['event'] >
	>
	type $rise_drag__x_shm_hitalama_map_book_tools_float_11 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_book_tools_float['x'] >
		,
		ReturnType< $rise_drag['x'] >
	>
	type $rise_drag__y_shm_hitalama_map_book_tools_float_12 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_book_tools_float['y'] >
		,
		ReturnType< $rise_drag['y'] >
	>
	export class $shm_hitalama_map_book_tools_float extends $mol_view {
		dragger_side( ): string
		left( ): string
		top( ): string
		max_height( ): string
		vertical( ): boolean
		Tools( ): $shm_hitalama_map_book_tools_float_quick
		Drag_left_icon_1( ): $mol_icon_dots_vertical
		Drag_left_icon_2( ): $mol_icon_dots_vertical
		drag_left_start( next?: any ): any
		Dragger_left( ): $mol_button_minor
		Drag_right_icon_1( ): $mol_icon_dots_vertical
		Drag_right_icon_2( ): $mol_icon_dots_vertical
		drag_right_start( next?: any ): any
		Dragger_right( ): $mol_button_minor
		x( next?: number ): number
		y( next?: number ): number
		Map_page( ): $shm_hitalama_map_page
		tool_mode( next?: string ): string
		draggers_suppressed( next?: boolean ): boolean
		pointer_pos( next?: readonly(number)[] ): readonly(number)[]
		drag_side( next?: string ): string
		attr( ): ({ 
			'dragger_side': ReturnType< $shm_hitalama_map_book_tools_float['dragger_side'] >,
		})  & ReturnType< $mol_view['attr'] >
		style( ): ({ 
			'left': ReturnType< $shm_hitalama_map_book_tools_float['left'] >,
			'top': ReturnType< $shm_hitalama_map_book_tools_float['top'] >,
			'maxHeight': ReturnType< $shm_hitalama_map_book_tools_float['max_height'] >,
		})  & ReturnType< $mol_view['style'] >
		sub( ): readonly(any)[]
		Drag( ): $rise_drag
	}
	
	export class $shm_hitalama_map_book_tools_float_quick extends $shm_hitalama_quick2_reorder {
		tool_mode( next?: string ): string
		draggers_suppressed( next?: boolean ): boolean
		available_ids( ): readonly(any)[]
		Select_icon( ): $mol_icon_cursor_default
		Drawing_icon( ): $mol_icon_pencil
		Rect_icon( ): $mol_icon_rectangle_outline
		Circle_icon( ): $mol_icon_circle_outline
		Text_icon( ): $mol_icon_format_text
		Markdown_icon( ): $mol_icon_language_markdown_outline
	}
	
}

//# sourceMappingURL=float.view.tree.d.ts.map